import { ISummarySettings } from "@services/getSettings";
import { TgAccountsI } from "@services/getTgAccounts";
import {
  IAccount,
  NotificationsEmails,
} from "@services/http/responses/AccountResponse";
import { Me } from "./reducer";
import { UserMeta } from "@services/editUser";

export enum ActionTypesMeE {
  SET_ME = "SET_ME",
  UPDATE_ME = "UPDATE_ME",
  SET_POOL_SETTINGS = "SET_POOL_SETTINGS",
  ADD_POOL_SETTING = "ADD_POOL_SETTING",
  EDIT_POOL_SETTING = "EDIT_POOL_SETTING",
  DELETE_POOL_SETTING = "DELETE_POOL_SETTING",
  SET_POOL_DIVIDER = "SET_POOL_DIVIDER",
  SET_USERS = "SET_USERS",
  CLEAR_ME = "CLEAR_ME",
  SET_NOTIFS_EMAILS = "SET_NOTIFS_EMAILS",
  SET_TG_ACCOUNTS = "SET_TG_ACCOUNTS",
  SET_LOADERS = "SET_LOADERS",
  SET_META = "SET_META",
}

export type SeparatorType = "." | "_";
export interface PoolDivider {
  name: string;
  separators: {
    _1: SeparatorType;
    _2: SeparatorType;
    _3: SeparatorType;
  };
}

export interface ActionBaseMe {
  type: ActionTypesMeE;
}

export interface ActionSetMe extends ActionBaseMe {
  payload: {
    accData: IAccount;
  };
}
export interface ActionUpdateMe extends ActionBaseMe {
  payload: {
    accData: IAccount;
  };
}

export interface IStoredSetting extends ISummarySettings {
  id: number;
  used_count: number;
  is_default?: boolean;
  props?: string;
}

export interface IReceivedSetting extends IStoredSetting {
  user_id: number;
  email: string;
}

export interface ActionSetPoolSettings extends ActionBaseMe {
  payload: {
    poolSettings: IStoredSetting[];
  };
}

export interface ActionAddPoolSetting extends ActionBaseMe {
  payload: IStoredSetting;
}

export interface ActionEditPoolSetting extends ActionBaseMe {
  payload: IStoredSetting;
}

export interface ActionDeletePoolSetting extends ActionBaseMe {
  payload: number;
}

export interface ActionSetPoolDivider extends ActionBaseMe {
  payload: {
    poolDivider: PoolDivider[];
  };
}

export interface ActionSetNotifsEmails extends ActionBaseMe {
  payload: {
    emails: NotificationsEmails[];
  };
}

export interface ActionSetTgAccounts extends ActionBaseMe {
  payload: {
    tgAccounts: TgAccountsI[];
  };
}

export interface ActionSetMeLoaders extends ActionBaseMe {
  payload: Me["loaders"];
}

export interface ActionSetMeta extends ActionBaseMe {
  payload: UserMeta;
}

